// Deterministic preview/localhost gate for the demo-shortcut UI.
//
// Even if the backend accidentally reports demo_mode=true in production (e.g.
// a packaged .env slipping through), the shortcuts must NEVER render on a
// production host. Treating this as a plain function keeps it unit-testable
// without needing a running browser.
//
// Allowed hosts (returns true):
//   * anything ending with ".preview.emergentagent.com"
//   * exactly "localhost" or "127.0.0.1"
// Everything else (florali.shop, *.emergent.host, *.emergent.sh, etc.)
// returns false.
export function isDemoHostAllowed(hostname) {
  if (typeof hostname !== "string" || !hostname) return false;
  const h = hostname.toLowerCase();
  if (h === "localhost" || h === "127.0.0.1") return true;
  if (h.endsWith(".preview.emergentagent.com")) return true;
  return false;
}

// Convenience for component use — defaults to the live window hostname.
export function isDemoShortcutsAllowed(hostname) {
  const h = hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
  return isDemoHostAllowed(h);
}
